import React from 'react';

interface UsersFiltersProps {
  searchInput: string;
  hasOrdersFilter: 'all' | 'with' | 'without';
  onSearchChange: (value: string) => void;
  onHasOrdersChange: (value: 'all' | 'with' | 'without') => void;
  onSubmit: () => void;
  onReset: () => void;
}

export const UsersFilters: React.FC<UsersFiltersProps> = ({
  searchInput,
  hasOrdersFilter,
  onSearchChange,
  onHasOrdersChange,
  onSubmit,
  onReset,
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm p-4">
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col md:flex-row gap-4 md:items-end">
          {/* Поиск */}
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Поиск
            </label>
            <input
              type="text"
              value={searchInput}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Email, имя или Telegram"
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400"
            />
          </div>

          {/* Наличие заказов */}
          <div className="w-full md:w-60">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Наличие заказов
            </label>
            <select
              value={hasOrdersFilter}
              onChange={(e) => onHasOrdersChange(e.target.value as 'all' | 'with' | 'without')}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400"
            >
              <option value="all">Все пользователи</option>
              <option value="with">Только с заказами</option>
              <option value="without">Без заказов</option>
            </select>
          </div>

          {/* Кнопки */}
          <div className="flex gap-2">
            <button
              type="button"
              onClick={onReset}
              className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-md hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors font-medium"
            >
              Сбросить
            </button>
            <button
              type="submit"
              className="px-6 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors font-medium"
            >
              Найти
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

